import {Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-category-tree',
  templateUrl: './category-tree.component.html',
  styleUrls: ['./category-tree.component.scss']
})
export class CategoryTreeComponent implements OnInit, OnDestroy, OnChanges {

  @Input() categories;
  @Input() key = 'children';
  @Input() editUrlPath = '/category/edit/';
  constructor() { }

  init() {
    if (this.categories && (this.categories as any).getContent) {
      this.categories = (this.categories as any).getContent().map(s => {
        s.isOpen = true;
        return s;
      });
    }
  }

  ngOnInit() {
    this.init();
  }

  open(i) {
    this.categories[i].isOpen = !this.categories[i].isOpen;
  }

  isArray(arr) {
    return Array.isArray(arr);
  }

  ngOnDestroy() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.init();
  }
}
